module.exports = __webpack_public_path__ + "dashboard/img/login-bg.358fdbcaac8962630873d4f909b15af3.jpg";